import {
  Button,
  Icon,
  Link,
  Loading
} from '@startlibs/components';
import {
  Errors,
  WithForm
} from '@startlibs/form';
import { useNavigate } from '@startlibs/components';
import {useToggle} from '@startlibs/core'
import React, { useEffect, useState } from 'react'
import _ from 'lodash/fp'
import {CASE_CLOSED, CASE_REVIEWED, UNDER_REVIEW, WAITING_MORE_INFORMATION} from '../enums/CaseState';
import {Card, HeaderButtons, PageContainer, PageFooter} from '../components/PageLayout';
import {CustomReportInfoBox} from './customReport/CustomReportInfoBox'
import {ExternalReportUpload} from '../request/components/ExternalReportUpload'
import {Header} from '../components/Header'
import {PdfReportFrame, PdfReportFrameWrapper} from '../request/components/PdfReportFrame';
import {PreviewForCaseRequest} from '../request/reviewedRequest/PreviewForCaseRequest'
import {PurviewFooter} from '../components/PurviewFooter'
import {SuccessBox} from '../components/InfoBox';
import {getJwt} from '../hooks/useJwt'
import {hasAnsweredAll} from '../request/utils'
import {jwtGetFetcher} from '../utils/authFetch'
import {useIframeIsLoading} from '../admin/steps/hooks/useIframeIsLoading'
import {useShareDialog} from '../hooks/useShareDialog'
import {useSubmitCase} from './dialogs/useSubmitCase';
import {useUploadCustomReport, useUploadDialogIsOpen} from './customReport/useUploadCustomReport'
import { FeedbackDialog } from './dialogs/FeedbackDialog';
import { lazyProviderInfo, lazyProviderInfoSec, lazyUserInfo } from '../components/WithProvider';
import { AssignmentStatusBox } from '../admin/steps/expertReview/ExpertReviewList';
import {FormattedMessage, useIntl} from "react-intl";
import { ExpertTimeCard, ExpertTimeHeading } from '../request/expertTime/ExpertTime';
import { EXPERT_TIME_HIDDEN, EXPERT_TIME_REQUIRED, getExpertTimeMode, useOwnExpertTime } from '../request/expertTime/expertTimeUtils';

export const ExpertReport = ({caseRequest, setCaseRequest, uploadPDF, feedbackPopup}) => {
  const intl = useIntl()
  const navigate = useNavigate()
  lazyUserInfo.read();
  const providerInfo = lazyProviderInfo.read()

  const expertReportSharing = providerInfo?.expertReportSharing

  const expertTimeMode = getExpertTimeMode(lazyProviderInfoSec.read())
  const expertTime = useOwnExpertTime(caseRequest.requestId)

  const submitReview = useSubmitCase(
    caseRequest,
    _.update('additionalFields',(additionalFields) => additionalFields || [],caseRequest.caseInfo),
    ({useCustomReport}) => {
      setCaseRequest(_.flow(
        _.set("state", CASE_REVIEWED),
        _.set('report.useCustomReport', useCustomReport)
      ))
      // Fullstory disabled for now
      // var now = new Date()
      // var eventProperties = {
      //   expertName_str: userInfo.firstName + ' ' + userInfo.lastName,
      //   expertMail_str: userInfo.login,
      //   expertId_int: userInfo.id,
      //   customer_str: providerInfo.name,
      //   dateTime_date: now,
      //   requestId_int: caseRequest.requestId,
      //   caseId_str: caseRequest.requestCode,
      //   caseState_str: caseRequest.state
      // }
      // window.FS.event('Expert Case Reviewed',eventProperties)
    }
  )

  const [, setHasFeedback] = useState(false);
  
  useEffect(() => {
    if(caseRequest.isCoReview){
      navigate(`/expert/case/${caseRequest.requestId}/overview`)
      return 
    }
    if(caseRequest.state === CASE_REVIEWED || caseRequest.readOnly){
      jwtGetFetcher(getJwt())(`/api/expert/feedback?requestId=${caseRequest.requestId}`)
        .then((_response) => {setHasFeedback(true)})
        .catch((_error) => {setHasFeedback(false);feedbackPopup.open()})
    }
  },[caseRequest])

  const isOpen = (caseRequest.state === UNDER_REVIEW || caseRequest.state === WAITING_MORE_INFORMATION) && !caseRequest.readOnly
  const [openShareDialog, shareDialog] = useShareDialog(caseRequest)
  const uploadCustomReport = useUploadCustomReport(caseRequest, setCaseRequest)

  const iframeIsLoading = useIframeIsLoading(caseRequest.report?.useCustomReport)

  const [isUploadDialogOpen] = useUploadDialogIsOpen()

  const showUpload = uploadPDF || (!hasAnsweredAll(caseRequest.caseInfo.questionsConsultant) && !caseRequest.report?.customReport)
  const caseCompletedWithoutReport = caseRequest.state === CASE_CLOSED && !caseRequest.report?.customReport && !caseRequest.report?.useCustomReport && !caseRequest.report
  const caseClosedNavigation = caseRequest.state === CASE_CLOSED &&
    <HeaderButtons noPrint>
      <div className="left-wrapper">
      </div>
      {!caseCompletedWithoutReport && <div className="right-wrapper">
        <Button.a
          href={`/api/report/download?token=${getJwt()}&requestId=${caseRequest.requestId}`}
          icon="download"
        ><FormattedMessage
          defaultMessage="Save PDF"
          description="Expert report save PDF button"
        /></Button.a>
        <Button.a
          target="_blank"
          href={`/api/report/preview?token=${getJwt()}&requestId=${caseRequest.requestId}`}
          icon="print"
        ><FormattedMessage
          defaultMessage="Print"
          description="Print button"
        /></Button.a>
        {expertReportSharing && <Button highlight onClick={openShareDialog} icon="send"><FormattedMessage
          defaultMessage="Share"
          description="Share button"
        /></Button>}
      </div>}
    </HeaderButtons>

  const caseNavigation =
    (
      (caseRequest.state === CASE_REVIEWED || caseRequest.readOnly) &&
      <Button css="margin-left:1rem" onClick={() => navigate(`/expert/case/${caseRequest.requestId}/questions`)}><FormattedMessage
        defaultMessage="View answers"
        description="Expert report view answers button"
      /></Button>
    ) ||
    (
      isOpen && <>
        <Button onClick={() => navigate(`/expert/case/${caseRequest.requestId}/questions`)}><FormattedMessage
          defaultMessage="Edit answers"
          description="Expert report edit answers button"
        /></Button>
        <Button
          highlight
          disabled={showUpload && !caseRequest.report?.customReport}
          onClick={submitReview}
        ><FormattedMessage
          defaultMessage="Submit review"
          description="Expert report submit review button"
        /></Button>
      </>
    )

  return !caseRequest.isCoReview && <> <PageContainer withPrint>
    <Header isExpert noPrint title={intl.formatMessage({
        defaultMessage: "Case report",
        description: "Expert report title"
      })}>
      {
        (caseRequest.state === CASE_REVIEWED || caseRequest.readOnly) &&
          <>
            {!caseCompletedWithoutReport && <SuccessBox>
              <Icon icon="check"/><span><FormattedMessage
              defaultMessage="Review already submitted"
              description="Expert report review already submitted"
            /></span>
            </SuccessBox>}
          </>
      }
      {
        caseRequest.state === CASE_CLOSED &&
        <SuccessBox>
          <Icon icon="check"/><span>{caseCompletedWithoutReport
          ? <FormattedMessage
            defaultMessage="Case already completed."
            description="Expert report case already completed message"
          />
          : <FormattedMessage
            defaultMessage="Report already completed."
            description="Expert report report already completed message"
          />
        }</span>
        </SuccessBox>
      }
      {caseNavigation}
    </Header>
    {caseClosedNavigation}

    {
      caseRequest.report?.customReport && isOpen &&
      <div css="@media print { display: none; }">
        <CustomReportInfoBox setCaseRequest={setCaseRequest} caseRequest={caseRequest}/>
      </div>
    }
    {
      !caseRequest.report?.customReport && isOpen && !showUpload &&
      <HeaderButtons noPrint>
        <div className="left-wrapper">
          <p css="margin-bottom:  0;"><FormattedMessage
            defaultMessage="Previewing default case report."
            description="Expert report previewing default case report message"
          /></p>
        </div>
        <div className="right-wrapper">
          <Button onClick={uploadCustomReport} small icon="upload"><FormattedMessage
            defaultMessage="Upload custom PDF report"
            description="Expert report upload custom PDF report button"
          /></Button>
        </div>
      </HeaderButtons>
    }
    {
      caseCompletedWithoutReport 
        ? <AssignmentStatusBox reviewed={caseRequest.state === CASE_CLOSED}>
            <div className="waitingBoxContent">
              <Icon icon={'check'}/>
              <h4>
                <FormattedMessage
                  defaultMessage="This case is already completed."
                  description="Expert report case already completed message title"
                />
              </h4>
              <p><FormattedMessage
                defaultMessage="The case has been marked as completed, but no report was generated."
                description="Expert report case already completed message"
              /></p>
            </div>
          </AssignmentStatusBox> 
        : (showUpload && !caseRequest.report?.useCustomReport)
          ? <UploadCustomReport caseRequest={caseRequest} setCaseRequest={setCaseRequest}/>
          : caseRequest.report?.useCustomReport
            ? <PdfReportFrameWrapper><PdfReportFrame
                pdfReport
                isUploadDialogOpen={isUploadDialogOpen}
                onLoad={iframeIsLoading.close}
                src={`/api/report/preview?token=${getJwt()}&requestId=${caseRequest.requestId}&refreshPdf=${caseRequest.pdfKey}#toolbar=0&navpanes=0`}
              />
                {iframeIsLoading.isOpen && <Loading absolute/>}
              </PdfReportFrameWrapper>
            : <PreviewForCaseRequest
                isExpert
                caseRequest={caseRequest}
              />
    }
    {
      expertTimeMode !== EXPERT_TIME_HIDDEN && expertTime.entry && <div css="@media print { display: none; }">
        <ExpertTimeHeading showNotice css="margin-top: 2rem;"/>
        <ExpertTimeCard
          entry={expertTime.entry}
          required={expertTimeMode === EXPERT_TIME_REQUIRED}
          canEdit={isOpen}
          onEdit={() => navigate(`/expert/case/${caseRequest.requestId}/questions#time`)}
        />
      </div>
    }
    {
      caseRequest.state !== CASE_CLOSED &&
      <PageFooter css="@media print { display: none; }">
        {caseNavigation}
      </PageFooter>
    }
    {caseClosedNavigation}
    {
      shareDialog
    }
  </PageContainer>
    <PurviewFooter/>
    {
      feedbackPopup.isOpen && <FeedbackDialog feedbackPopup={feedbackPopup} requestId={caseRequest.requestId} />
    }
  </>
}


const UploadCustomReport = ({caseRequest, setCaseRequest}) => {
  const isUploading = useToggle()

  return <>
    <p>
      <FormattedMessage
        defaultMessage={`<strong>Not all answers were provided in "Questions & Answers".</strong>
      Would you like to upload a custom PDF report with your review?`}
        description="Upload custom report message"
        values={{
          strong: (...chunks) => <strong>{chunks}</strong>
        }}
      />
    </p>
    <Card>
      {isUploading.isOpen && <FormattedMessage
        defaultMessage="Uploading..."
        description="Uploading message"
      />}
      <WithForm>
        <ExternalReportUpload
          url={"/api/customReport?requestId=" + caseRequest.requestId}
          onSuccess={() => setCaseRequest(_.flow(_.set('report.useCustomReport', true), _.set('pdfKey', Date.now()), _.set('report.customReport', true)))}
        />
        <Errors/>
      </WithForm>
    </Card>
    <p css="margin-bottom:2rem">
      <FormattedMessage
        defaultMessage={`You can also <link>insert your answers</link> for generating a pre-formatted Expert View report.`}
        description="Upload custom report insert answers message"
        values={{
          link: (...chunks) => <Link className="link" to={`/expert/case/${caseRequest.requestId}/questions`}>{chunks}</Link>
        }}
      />
      </p>
  </>
}
